<template>
  <div class="container">
    <h1 class="title">
      <el-button
        :type="isViewingDefaultVersion ? 'success' : 'info'"
        @click="downloadApplicationForm"
        :disabled="!isViewingDefaultVersion && !reportUrl"
      >
        {{ isViewingDefaultVersion ? "活动申报表下载" : "下载往届论文" }}
      </el-button>
      <span style="color: #f00" v-if="isViewingDefaultVersion"
        >*学校正式报名需提交盖章后的申报表</span
      >
    </h1>
    <div v-if="defaultMatchVersion" class="registration-notice">
      <i class="el-icon-info"></i>
      当前仅开放第 {{ defaultMatchVersion }} 届报名。 您当前选择的是第
      {{ currentMatchVersion }} 届。
    </div>

    <el-form
      v-if="isLoggedIn"
      ref="form"
      :model="form"
      :rules="rules"
      label-width="130px"
      :inline="true"
      class="flexible-inline-form"
    >
      <!-- 表单项保持不变 -->
      <el-form-item label="省份:" prop="province">
        <el-input v-model="form.province"></el-input>
      </el-form-item>
      <el-form-item label="学校名称:" prop="schoolName">
        <el-input v-model="form.schoolName"></el-input>
      </el-form-item>
      <el-form-item label="参加组:" prop="schoolType">
        <el-radio-group v-model="form.schoolType">
          <el-radio :label="0">小学组</el-radio>
          <el-radio :label="1">中学组</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="联系地址:" prop="address">
        <el-input v-model="form.address"></el-input>
      </el-form-item>
      <el-form-item label="指导老师1:" prop="teacher1">
        <el-input v-model="form.teacher1"></el-input>
      </el-form-item>
      <el-form-item label="联系方式:" prop="teacher1Contact">
        <el-input v-model="form.teacher1Contact"></el-input>
      </el-form-item>
      <el-form-item label="指导老师2:">
        <el-input v-model="form.teacher2"></el-input>
      </el-form-item>
      <el-form-item label="联系方式:" prop="teacher2Contact">
        <el-input v-model="form.teacher2Contact"></el-input>
      </el-form-item>
      <el-form-item label="学生姓名:" prop="studentName" class="full-width">
        <el-input
          v-model="form.studentName"
          placeholder="3~8名学生姓名,请使用“，”隔开"
        ></el-input>
      </el-form-item>
      <el-form-item label="上传报名表:" prop="applyUrl">
        <el-upload
          class="avatar-uploader"
          :action="action"
          multiple
          list-type="picture"
          :limit="1"
          :before-upload="handleBefore"
          :on-success="handleSuccess"
          :show-file-list="false"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="备注:" class="full-width">
        <el-input
          type="textarea"
          v-model="form.remark"
          :maxlength="100"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item
        label="小程序绑定码:"
        class="full-width"
        label-width="140px"
        v-if="form.id"
      >
        <el-input
          v-model="bindCode"
          placeholder="请点击按钮生成绑定码"
          :readonly="true"
          style="width: 300px; margin-right: 20px"
        >
        </el-input>
        <el-button
          type="warning"
          @click="generateCode"
          :loading="bindCodeLoading"
        >
          {{ bindCode ? "重新生成" : "生成绑定码" }}
        </el-button>
        <div class="el-upload__tip" style="line-height: 1.4; margin-top: 10px">
          *用于将您的活动报名信息绑定至“春之天气”公众号中，也可邀请其他组员在公众号中填写此绑定码。有效期为12小时。
        </div>
      </el-form-item>
    </el-form>
    <qrcode />
    <div v-if="isLoggedIn" style="text-align: center; margin-top: 20px">
      <!-- [修改] 禁用提交按钮的条件 -->
      <el-button
        type="primary"
        style="width: 400px"
        @click="submit"
        :disabled="!isViewingDefaultVersion"
        >提交</el-button
      >
    </div>
    <div
      v-if="isLoggedIn && disabled"
      style="text-align: center; margin-top: 20px"
    >
      恭喜!您已报名成功!!!
    </div>
  </div>
</template>

<script >
import { $activity } from "@/services";
import { BASE } from "@/services/base";
import { saveAs } from "file-saver";

import { mapGetters, mapState } from "vuex";
import Qrcode from "@/components/Qrcode.vue";

export default {
  components: {
    Qrcode,
  },
  data() {
    const studentNameMin = 3; // 学生姓名下限
    const studentNameMax = 8; // 学生姓名上限
    const validateStudentNames = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请填写学生姓名"));
      }
      if (value.includes(",")) {
        return callback(new Error("请使用中文逗号“，”分隔姓名"));
      }
      const names = value
        .split("，")
        .map((name) => name.trim())
        .filter((name) => name.length > 0);
      if (names.length < studentNameMin || names.length > studentNameMax) {
        return callback(
          new Error(
            `请输入${studentNameMin}-${studentNameMax}名学生姓名，并用“，”隔开`
          )
        );
      }
      callback();
    };
    const phoneRegex = /^1[3-9]\d{9}$/;

    return {
      isLoggedIn: false,
      form: {},
      action: BASE + "/server/common/upload",
      studentNameMin,
      studentNameMax,
      rules: {
        province: [
          { required: true, message: "请填写学校所在省份", trigger: "blur" },
        ],
        schoolName: [
          { required: true, message: "请填写学校完整名称", trigger: "blur" },
        ],
        schoolType: [
          { required: true, message: "请选择参加组", trigger: "blur" },
        ],
        teacher1: [
          { required: true, message: "请填写指导老师1", trigger: "blur" },
        ],
        teacher1Contact: [
          {
            required: true,
            message: "请填写指导老师1的联系方式",
            trigger: "blur",
          },
          {
            pattern: phoneRegex,
            message: "请输入正确的11位手机号码",
            trigger: "blur",
          },
        ],
        teacher2Contact: [
          {
            pattern: phoneRegex,
            message: "请输入正确的11位手机号码",
            trigger: "blur",
          },
        ],
        address: [{ message: "请填写学校详细地址", trigger: "blur" }],
        studentName: [
          {
            required: true,
            validator: validateStudentNames,
            trigger: "blur",
          },
        ],
        applyUrl: [
          { required: true, message: "请上传报名表扫描件", trigger: "blur" },
        ],
      },
      disabled: false,
      imageUrl: "",
      applicationFormUrl:
        "https://kxwj.cn/observer/files/附件1. 活动申报表（第四届校园气象观测和应用挑战赛）.docx",
      reportUrl: null,
      bindCode: null,
      bindCodeLoading: false,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
    ...mapGetters("match", ["currentMatchVersion", "defaultMatchVersion"]),
    isViewingDefaultVersion() {
      if (!this.currentMatchVersion || !this.defaultMatchVersion) {
        return true;
      }
      return this.currentMatchVersion === this.defaultMatchVersion;
    },
  },
  created() {
    // 检查登录状态
    const userInfo = this.userInfo;
    if (!userInfo || !userInfo.id) {
      this.$message.error("您尚未登录，请先登录");
      this.$router.push({
        name: "login",
        query: { redirect: this.$route.fullPath },
      });
      this.isLoggedIn = false;
      return;
    }
    if (userInfo.type === 9) {
      this.$router.push("/review");
      return;
    }
    this.isLoggedIn = true;
    this.form.userId = userInfo.id;
    const versionFromUrl = this.$route.query.version;
    if (versionFromUrl) {
      this.$store.dispatch("match/updateMatchVersion", versionFromUrl);
    }
    this.$store.dispatch("match/fetchMatchVersionList");

    this.getInfo(this.currentMatchVersion);
  },
  methods: {
    async downloadApplicationForm() {
      let urlToDownload;
      let defaultFileName;
      if (!this.isViewingDefaultVersion && this.reportUrl) {
        urlToDownload = this.reportUrl;
        defaultFileName = "往届论文";
      } else {
        urlToDownload = this.applicationFormUrl;
        defaultFileName = "活动申报表.docx";
      }

      if (!urlToDownload) {
        this.$message.warning("没有可下载的文件。");
        return;
      }

      try {
        this.$notify.info("文件下载中，请稍候...");

        const urlParts = urlToDownload.split("/");
        const fileName = urlParts[urlParts.length - 1] || defaultFileName;
        saveAs(urlToDownload, fileName);
        this.$notify.success("文件下载成功！");
      } catch (error) {
        console.error("下载文件失败:", error);
        this.$notify.error("文件下载失败，请稍后重试。");
      }
    },
    async getInfo(matchVersion) {
      // 1. [新增] 检查 'auto=true' 查询参数
      const autoRedirect = this.$route.query.auto === "true";

      // 2. 确保 currentMatchVersion 存在
      if (!matchVersion || !this.isLoggedIn) {
        setTimeout(() => this.getInfo(this.currentMatchVersion), 200);
        return;
      }

      try {
        const res = await $activity.getSignDetail(
          this.form.userId,
          matchVersion
        );

        if (res.code === 200 && res.data?.id) {
          // --- 1. 用户已报名 (for this matchVersion) ---
          this.reportUrl = res.data.reportUrl || null;
          this.bindCode = res.data.bindCode || null;
          // 3. [新增] 检查是否需要自动重定向
          if (autoRedirect && res.data.matchVersion == matchVersion) {
            // 场景 1: 从首页来 (auto=true) 且已报名 -> 重定向
            this.$message.success("您已报名本届活动，即将跳转到数据上传页...");
            this.$router.push("/uploadData");
          } else {
            // 场景 2: 从侧边栏来 (auto=false) 且已报名 -> 加载数据, 停留在本页
            this.form = res.data;
            this.imageUrl = res.data.applyUrl;
            this.disabled = res.data.matchVersion === matchVersion;
          }
        } else {
          // --- 2. 用户未报名 (或API失败) ---
          // 停留在本页, 显示空表单 (auto=true 或 false 行为一致)
          this.form = { userId: this.form.userId };
          this.imageUrl = "";
          this.disabled = false;
          this.reportUrl = null;
          this.bindCode = null;
        }
      } catch (error) {
        console.error("获取报名详情失败:", error);
        // 处理网络错误等
        this.form = { userId: this.form.userId };
        this.imageUrl = "";
        this.disabled = false;
        this.reportUrl = null;
      }
    },
    async generateCode() {
      if (!this.form.id) {
        this.$message.error("未找到报名信息ID，无法生成绑定码。");
        return;
      }
      this.bindCodeLoading = true;
      try {
        const res = await $activity.generateBindCode(this.form.id);

        if (res.code === 200 && res.data) {
          this.bindCode = res.data;
          this.$message.success("绑定码生成成功！");
        } else {
          this.$message.error(res.msg || "生成失败，请重试");
        }
      } catch (error) {
        console.error("生成绑定码失败:", error);
        this.$message.error("生成绑定码接口请求失败");
      } finally {
        this.bindCodeLoading = false;
      }
    },
    handleBefore(file) {
      if (file.size / 1024 / 1024 > 5) {
        this.$message.error("上传图片不能大于5M");
        return false;
      }
      this.imageUrl = URL.createObjectURL(file);
      return true;
    },
    handleSuccess(response) {
      if (response.code === 200) {
        this.form.applyUrl = response.data.url;
      }
    },
    submit() {
      if (!this.isViewingDefaultVersion) {
        this.$message.error(
          `当前仅开放第 ${this.defaultMatchVersion} 届报名，无法提交。`
        );
        return;
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          $activity
            // 使用 this.currentMatchVersion
            .setSign({ ...this.form, matchVersion: this.currentMatchVersion })
            .then((res) => {
              if (res.code === 200) {
                this.$message.success("报名成功，即将跳转到数据上传页");
                this.$router.push("/uploadData");
              } else {
                // [新增] 处理报名失败的情况
                this.$message.error(res.msg || "报名失败，请稍后重试");
              }
            })
            .catch((error) => {
              console.error("报名失败:", error);
              this.$message.error("报名接口请求失败");
            });
        }
      });
    },
  },
  watch: {
    currentMatchVersion(newValue) {
      if (newValue) {
        this.getInfo();
      }
    },
  },
};
</script>

<style scoped lang="less">
.container {
  padding: 40px;
  width: 1000px;
  margin: 0 auto;
  .title {
    text-align: center;
    padding-bottom: 20px;
    font-size: 20px;
    font-weight: bold;
    /deep/ .el-button {
      font-size: 22px;
    }
  }
  .registration-notice {
    background-color: #f4f4f5;
    color: #909399;
    padding: 10px 15px;
    border-radius: 4px;
    margin-bottom: 20px;
    font-size: 16px;
    display: flex;
    align-items: center;
    i {
      margin-right: 8px;
      font-size: 18px;
    }
  }
}
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.el-divider__text {
  font-size: 24px;
}
/deep/.el-input__inner,
/deep/.el-radio__label,
/deep/.el-form-item__label,
/deep/ .el-select .el-input__inner {
  font-size: 20px;
}

.flexible-inline-form {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  /deep/ .el-form-item {
    width: 48%;
    display: flex;
    margin-right: 0;

    .el-input,
    .el-radio-group,
    .el-upload,
    .el-select {
      width: 100%;
    }

    .el-input__inner {
      width: 100%;
    }

    &__content {
      flex: 1;
      min-width: 0;
    }
  }

  /deep/ .el-form-item.full-width {
    width: 100%;
    margin-top: 10px;
  }
}
</style>

